/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpenInvitationConfigCto } from '../../models/open-invitation-config-cto';

export interface GetByCompanyIdAsync$Json$Params {
  companyId: number;
}

export function getByCompanyIdAsync$Json(http: HttpClient, rootUrl: string, params: GetByCompanyIdAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OpenInvitationConfigCto>>> {
  const rb = new RequestBuilder(rootUrl, getByCompanyIdAsync$Json.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OpenInvitationConfigCto>>;
    })
  );
}

getByCompanyIdAsync$Json.PATH = '/open-invitation-config/company-id/{companyId}';
